import type { SocToken } from '@/styles/tokens'

/** Health ink: healthy → wounded → critical. */
export function healthTone(value: number, max: number): SocToken {
  const r = max > 0 ? value / max : 0
  if (r > 0.6) return 'success'
  if (r > 0.3) return 'warning'
  return 'danger'
}
